import Index from '@/pages/reserve/Index'
import List from '@/pages/reserve/List'
import Create from '@/pages/reserve/Create'
import Modify from '@/pages/reserve/Modify'
import OrgList from '@/pages/reserve/OrgList'
import OrgCreate from '@/pages/reserve/OrgCreate'
import OrgModify from '@/pages/reserve/OrgModify'
import BelongList from '@/pages/reserve/BelongList'
import BelongCreate from '@/pages/reserve/BelongCreate'
import BelongModify from '@/pages/reserve/BelongModify'

export default {
  path: 'reserve',
  component: Index,  
  children: [
    {
      path: 'index',
      component: List
    },
    {
      path: 'create',
      component: Create
    },
    {
      path: 'modify/:id',
      component: Modify
    },
    {
      path: 'orglist/:reserveid',
      component: OrgList
    },
    {
      path: 'orgcreate/:reserveid',
      component: OrgCreate
    },
    {
      path: 'orgmodify/:reserveid/:id',
      component: OrgModify
    },
    {
      path: 'belonglist/:historyid/:reserveid',
      component: BelongList
    },
    {
      path: 'belongcreate/:historyid/:reserveid/:userid',
      component: BelongCreate
    },
    {
      path: 'belongmodify/:historyid/:reserveid/:id',
      component: BelongModify
    }
  ]
}

